import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElInput, ElDatePicker, ElButton, FormInstance, FormRules } from 'element-plus';
    import { useStore } from 'vuex';
    import { Event } from '@/services/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EventsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Array<Event>>([])
    const formRef = ref<FormInstance>()

    const rules = reactive<FormRules<{q: string, dates: Array<string>}>>({
        q: [{required: false, message: 'Selecione a imagem'}],
        dates: [{required: true, message: 'Selecione um intervalo'}]
    })

    const searchData = reactive<{q: string, dates: Array<string>}>({q: '', dates: []})

    const getEvents = async (q: string | false = false, dates: Array<string> | undefined | false = false) => {
        loading.value = true
        const params = new URLSearchParams()
        if (q && q.trim().length > 0) {
            params.append('q', q)
        } 
        if (dates) {
            params.append('start', new Date(dates[0]).toISOString())
            params.append('end', new Date(dates[1]).toISOString())
        }
        const res = await Api.get(`admin/events?${params.toString()}`)
        if (res.status == 200) {
            data.value = res.data.events
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    const search = async () => {
        loading.value = true
        await getEvents(searchData.q, searchData.dates)
    }
    onBeforeMount(async () => {
        await getEvents()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getEvents()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Eventos" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          "label-position": "top",
          inline: "",
          model: searchData
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              label: "pesquisar",
              class: "col-12 col-md-4 col-lg-3",
              prop: "q"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  name: "q",
                  modelValue: searchData.q,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchData.q) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Datas dos eventos",
              class: "col-12 col-md-5 col-lg-4",
              prop: "dates"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElDatePicker), {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Desde",
                  "end-placeholder": "Até",
                  modelValue: searchData.dates,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchData.dates) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), { label: "buscar" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Procurar eventos", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Preço normal', prop: 'price'},
                {label: 'Preço VIP', prop: 'vip_price'},
                {label: 'Data', prop: 'event_time'},
            ],
          data: data.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Local",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.area.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    tag: "router-link",
                    to: '/events/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})